/**
 * @generated SignedSource<<69fd523d57f4921bd673cee831a61673>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SiteNav_viewer$data = {
  readonly navigation: {
    readonly modules: ReadonlyArray<{
      readonly imageLinkData: {
        readonly path: string | null;
      };
      readonly items: ReadonlyArray<{
        readonly __typename: "NavigationTopLevel";
      } | null> | null;
      readonly name: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SiteNavDropdownContent_navigationModule" | "SiteNavItem_navigationModule">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "SiteNav_viewer";
};
export type SiteNav_viewer$key = {
  readonly " $data"?: SiteNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SiteNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "previewKey"
    },
    {
      "kind": "RootArgument",
      "name": "variantId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNav_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "previewKey"
        },
        {
          "kind": "Variable",
          "name": "variantId",
          "variableName": "variantId"
        }
      ],
      "concreteType": "Navigation",
      "kind": "LinkedField",
      "name": "navigation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NavigationModule",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SiteNavItem_navigationModule"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SiteNavDropdownContent_navigationModule"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "imageLinkData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NavigationTopLevel",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b862fd392421fe177ca47e8f8f422005";

export default node;
